import { createModelPermissions } from "components/permissions/utils/model-permission-generator";

const modelPermissions = createModelPermissions({
  modelName: "stand_types",
  basePath: "/stand-types",
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true
  }
});

const StandConst = {
  ...modelPermissions,
  // Additional rights for equipment-add-rule-form
  permissions: {
    ...modelPermissions.permissions,
    DELETE_EQUIPMENT: {
      slug: "permission_delete_stand_type_equipment",
      entryPoint: "library",
      groupName: "permission_group_stand_types",
      action: "permission_action_delete"
    },
    UPDATE_EQUIPMENT: {
      slug: "permission_update_stand_type_equipment",
      entryPoint: "library",
      groupName: "permission_group_stand_types",
      action: "permission_action_update"
    },
    DELETE_FLOORING: {
      slug: "permission_delete_stand_type_flooring",
      entryPoint: "library",
      groupName: "permission_group_stand_types",
      action: "permission_action_delete"
    },
    UPDATE_FLOORING: {
      slug: "permission_update_stand_type_flooring",
      entryPoint: "library",
      groupName: "permission_group_stand_types",
      action: "permission_action_update"
    }
  }
};

export default StandConst;
